module.exports = __webpack_public_path__ + "static/media/municipio-204.75bfd012.png";